module.exports = __webpack_public_path__ + "static/media/open-faq-icon.fcbbe897.svg";